import { TemplateResult, html, nothing } from 'lit';
import { ifDefined } from 'lit/directives/if-defined.js';
import { unsafeHTML } from 'lit/directives/unsafe-html.js';
import type { TefComs4csMicroFrontend } from '@src/components/tef-coms4cs.js';
import { comsStore } from '@src/state/ComsStore.js';

export function historyTemplate(this: TefComs4csMicroFrontend): TemplateResult {
  if (!comsStore.history || !comsStore.history.data) {
    return nothing as unknown as TemplateResult;
  }

  const { history } = comsStore;

  const historyItemTemplate = this.getTemplateFn('historyItemTemplate');

  if (history.client.error) { // TODO: render error and spinner on history page
    return html`
      <div>
        error loading history: ${history.client.error}
      </div>
    `;
  }

  return html`
    <div class="section section-buttons">
        <button
          class="button button-border"
          @click=${() => { /* eslint-disable @typescript-eslint/indent */
          history.configId = undefined;
          } /* eslint-enable @typescript-eslint/indent */}
        >
        Zurück
        </button>
    </div>
   <div class="section section-history">
      <p>
       ${unsafeHTML(history.consentShortScope)}
      </p>
      <tef-coms-pager items-per-page="5" items-total="${ifDefined(history.data?.total)}" page="${history.currentPage + 1}"></tef-coms-pager>

      <div class="section">
        ${history.data!.data.map(historyItemTemplate)}
      </div>
    </div>
  `;
}
